import {  VerticalLayout } from "../components/layout"
import { ThemeColorPicker } from "../molecule/themeColorPicker"
import { useState } from "react";
import { SettingHeader } from "./SettingHeader";
import ThemePaletPicker from "./themePaletPicker";


export const ThemeColorContent = ({setColor, colors}) => {
    const colorPresets = [
        {
            "name": "Expligo standaard",
            "colors": {
                "primary": "#486688",
                "secondary": "#486688",
                "sidebar": "#ffffff",
                "background": "#f8f9fa",
                "cards": "#ffffff",
                "topbar": "#ffffff",
                "borders": "#f1f1f1",
                "text": "#333333",
                "card_text": "#333333",
                "sub_text": "#333333",
                "borders2": "#f1f1f1"
            }
        },
        {
            "name": "Expligo donker",
            "colors": {
                "primary": "#1E1E1E",
                "secondary": "#575757",
                "sidebar": "#1E1E1E",
                "background": "#121212",
                "cards": "#222222",
                "topbar": "#1E1E1E",
                "borders": "#575757",
                "text": "#E1E1E1",
                "card_text": "#E1E1E1",
                "sub_text": "#E1E1E1",
                "borders2": "#575757"
            }
        },
        
    ]; // Later toevoegen...
    const colorOptions = [
        {
            key:"primary",
            title: "Primaire kleur",
            id: "primary",
            description: "Primaire kleur voor je thema, wordt ongeveer overal gebruikt.",
            default: "#486688",
        },
        {
            key:"borders",
            title: "Randen",
            id: "borders",
            description: "Kleur die wordt gebruikt voor de randen",
            default: "#486688",
        },
        {
            key:"sidebar",
            title: "Navigatie",
            id: "sidebar",
            description: "Kleur die wordt gebruikt voor de zijbalk.",
            default: "#486688",
        },
        {    key:"background",
            title: "Achtergrond",
            id: "background",
            description: "Kleur die wordt gebruikt als achtergrond.",
            default: "#FF5733",
        }
        ,
        {
            key:"cards",
            title: "Kaartkleur",
            id: "cards",
            description: "Kleur die wordt gebruikt voor de randen",
            default: "#FF5733",
        }
        ,
        {
            key:"topbar",  
            title: "top navigatie",
            id: "topbar",
            description: "Kleur die wordt gebruikt voor de bovenste navigatie en zoekbalk",
            default: "#FF5733",
        }
        ,
        {
            key:"borders2",
            title: "Scheidingslijnen",
            id: "borders2",
            description: "Kleur die wordt gebruikt voor de randen",
            default: "#FF5733",
        }
        ,
        {
            key:"text",
            title: "Tekstkleuren",
            id: "text",
            description: "Kleur die wordt gebruikt voor de teksten",
            default: "#FF5733",
        }
        ,
        {
            key:"card_text",
            title: "Tekstkleuren in kaarten",
            id: "card_text",
            description: "Kleur die wordt gebruikt in componenten zoals kaarten",
            default: "#FF5733",
        }
        ,
        {
            key:"sub_text",
            title: "Secondaire tekst",
            id: "sub_text",
            description: "Kleinere tekst ter ondersteuning van de hoofdtekst",
            default: "#FF5733",
        }
      
    ]
    
    
    const handlePresetChange = (e) => {

        setColor(e)
      
    }

    function setColorNow(value, color) {
        const copyColor = {...colors}
        copyColor[value] = color
        setColor(copyColor)
        console.log(copyColor)      

    }

    return(
        <VerticalLayout className={"theme-create-content"} >
            <SettingHeader title="Kleuren" description="Pas hier de kleuren van Expligo aan"/>
            <ThemePaletPicker options={colorPresets} onSwitch={(e) => handlePresetChange(e)}/>

            <p className="phone-no-margin-left" style={{"color": "var(--grey-800)", "fontSize": "14px", "margin": "0px 1rem 0.5rem 1rem", "fontWeight": "bold"}}>Kies je kleuren</p>
            <VerticalLayout style={{gap: "0.5rem", overflowY: "scroll", maxHeight: "20rem"}}>
                {colorOptions.map((item, index) => {
                    return(
                        <ThemeColorPicker colorName={item.title} colorValue={colors[item.id]} setColor={(v) => setColorNow(item.id, v)} />
                    )
                })}
            </VerticalLayout>
        </VerticalLayout>

    )
}

export const HeaderTheme = ({title, description}) => {

    return(
       <VerticalLayout>
        <h3>{title}</h3>
        <h5>{description}</h5>
       </VerticalLayout>
    )
}